import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=68012178&scoped=true"
import script from "./UserName.vue?vue&type=script&setup=true&lang=js"
export * from "./UserName.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserName.vue?vue&type=style&index=0&id=68012178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68012178",
  null
  
)

export default component.exports